import * as R from 'ramda'

const pickKeysWithValidValue = R.pickBy((value, key) => {
  const isValid = val => !R.isNil(val) && !R.isEmpty(val)
  if (key === 'listId') return false
  // exclude listId while comparing.
  else if (Array.isArray(value)) {
    return isValid(value.filter(isValid))
  }
  return isValid(value)
})

const formatFilterOp = filterData => {
  if (typeof filterData.filterOp === 'string' && !!filterData.filterOp) {
    filterData.filterOp = [filterData.filterOp]
  }
}

/**
 * This functions tells if there is any change in the filter's state from the time it was loaded.
 * @param defaultFilters
 * @param listFilterData
 * @param currentFilters
 * @param isList
 * @returns {boolean}
 */
export default (defaultFilters, listFilterData, currentFilters, isList) => {
  const loadedFilterData = R.clone(listFilterData)
  const filterData = R.clone(currentFilters)
  const initialState = isList ? loadedFilterData : defaultFilters
  formatFilterOp(initialState)
  formatFilterOp(filterData)
  return !R.equals(pickKeysWithValidValue(initialState), pickKeysWithValidValue(filterData))
}
